import { call, put, takeLatest } from 'redux-saga/effects';
import types from '../actions/informe.actions';
import api from "../../../../api/api";

export function* saveData() {
    yield takeLatest(types.INFORMES_SAVE_DATA, takeLatestSaveData);
}

function* takeLatestSaveData({ payload }) {
console.log({ ...payload.values })
    let url = `/v1/informeHitsPositivos/generaInforme`;
    let response = yield call(api.post, url, { ...payload.values });

    if (response.status === 200) {
        payload.onSuccess(response.data.metadata[0].dato, response.data.response.data);
    } else {
        payload.onError(response.data.metadata[0].dato);
    }
}